import { DIETARY_VENDOR_FIELDS } from './DietaryFields';
import { EMERGENCY_SERVICE_VENDOR_FIELDS } from './EmergencyServiceFields';
import { GENERAL_AND_ADMIN_VENDOR_FIELDS } from './GeneralAndAdminFields';
import { HOUSEKEEPING_VENDOR_FIELDS } from './HousekeepingFields';
import { MAINTENANCE_VENDOR_FIELDS } from './MaintenanceFields';
import { NURSING_VENDOR_FIELDS } from './NursingFields';
import { THERAPY_VENDOR_FIELDS } from './TherapyFields';
import { THIRD_PARTY_SERVICES_FIELDS } from './ThirdPartyServicesFields';

export const VENDOR_SECTIONS = [
  { title: 'Nursing', fields: NURSING_VENDOR_FIELDS },
  { title: 'Therapy', fields: THERAPY_VENDOR_FIELDS },
  { title: 'Dietary', fields: DIETARY_VENDOR_FIELDS },
  { title: 'Housekeeping & Laundry', fields: HOUSEKEEPING_VENDOR_FIELDS },
  { title: 'Maintenance', fields: MAINTENANCE_VENDOR_FIELDS },
  { title: 'General/Admin', fields: GENERAL_AND_ADMIN_VENDOR_FIELDS },
  { title: 'Emergency Service Vendors', fields: EMERGENCY_SERVICE_VENDOR_FIELDS },
  { title: 'Third Party Services', fields: THIRD_PARTY_SERVICES_FIELDS },
];

export const VENDOR_FIELDS = VENDOR_SECTIONS.flatMap((section) => section.fields);
